import { useEffect, useState } from 'react';
import { Edit3, Loader2 } from 'lucide-react';
import ModalShell from '../ui/ModalShell';
import { SECTION_COLOR } from './receptUtils';

/**
 * Přejmenování varianty produktu (např. „Varianta 2" → „Velká").
 *
 * Rychlá akce, takže modal a ukládá se hned — nečeká na Uložit hlavičky
 * a nezakládá revizi receptury, název varianty na složení nic nemění.
 * Prázdné pole = základní varianta bez přívlastku.
 */
export default function PrejmenovatVariantuModal({ open, onClose, isDark, nazevProduktu, varianta, onUlozit }) {
    const [hodnota, setHodnota] = useState('');
    const [chyba, setChyba] = useState('');
    const [ukladam, setUkladam] = useState(false);

    useEffect(() => {
        if (open) { setHodnota(varianta || ''); setChyba(''); setUkladam(false); }
    }, [open, varianta]);

    const mutedColor = isDark ? 'rgba(255,255,255,0.50)' : 'var(--text-muted, #94a3b8)';
    const bezeZmeny = hodnota.trim() === (varianta || '').trim();

    const uloz = async () => {
        if (bezeZmeny) { onClose?.(); return; }
        setUkladam(true); setChyba('');
        try {
            await onUlozit(hodnota.trim());
            onClose?.();
        } catch (e) {
            setChyba(e?.error || e?.message || 'Nepodařilo se přejmenovat');
            setUkladam(false);
        }
    };

    return (
        <ModalShell open={open} onClose={onClose} isDark={isDark} ikona={Edit3} barva={SECTION_COLOR}
            nadpis="Přejmenovat variantu" sirka={400} zavritLze={!ukladam}
            paticka={(
                <div className="flex justify-end gap-2">
                    <button onClick={onClose} disabled={ukladam}
                        className="rounded-lg px-3 py-1.5 text-xs font-medium"
                        style={{ background: 'none', border: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)'}`, color: 'var(--text-secondary)', cursor: 'pointer' }}>
                        Zrušit
                    </button>
                    <button onClick={uloz} disabled={ukladam}
                        className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold text-white"
                        style={{ background: SECTION_COLOR, border: 'none', cursor: ukladam ? 'default' : 'pointer', opacity: ukladam ? 0.6 : 1 }}>
                        {ukladam && <Loader2 size={13} className="animate-spin" />} Přejmenovat
                    </button>
                </div>
            )}>
            <div className="p-4 space-y-2">
                {nazevProduktu && <p className="text-xs" style={{ color: mutedColor }}>{nazevProduktu}</p>}
                <input value={hodnota} onChange={e => setHodnota(e.target.value)} autoFocus maxLength={50}
                    onKeyDown={e => { if (e.key === 'Enter') uloz(); }}
                    placeholder="Základní"
                    className="w-full rounded-lg px-3 py-2 text-base"
                    style={{
                        background: isDark ? 'rgba(255,255,255,0.05)' : 'var(--surface-base)',
                        border: `1px solid ${chyba ? 'rgba(239,68,68,0.6)' : (isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)')}`,
                        color: 'var(--text-primary)', outline: 'none',
                    }} />
                {chyba
                    ? <p className="text-xs" style={{ color: '#EF4444' }}>{chyba}</p>
                    : <p className="text-[11px]" style={{ color: mutedColor }}>Prázdné = základní varianta. Uloží se hned.</p>}
            </div>
        </ModalShell>
    );
}
